import { FinanceType } from '../constants';

export const isLease = (
  financeType: FinanceType | null | undefined,
): financeType is FinanceType.LEASE => financeType === FinanceType.LEASE;

export const isCash = (
  financeType: FinanceType | null | undefined,
): financeType is FinanceType.CASH => financeType === FinanceType.CASH;

export const isPurchase = (
  financeType: FinanceType | null | undefined,
): financeType is FinanceType.PURCHASE => financeType === FinanceType.PURCHASE;
